// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 60 60" {...rest} unit={unit}>
		<title>Not Selected</title>
		<g>
			<circle id="Oval" fill="#F42D2D" cx="30" cy="30" r="30"></circle>
			<path 
				d="M29.9999996,36.9999998 L20.4999998,46.4999997 
				L13.4999998,39.4999997 L22.9999997,29.9999998 L13.4999998,20.4999999 
				L20.4999998,13.5 L29.9999996,22.9999999 L39.4999995,13.5 
				L46.4999995,20.4999999 L36.9999996,29.9999998 L46.4999995,39.4999997 
				L39.4999995,46.4999997 L29.9999996,36.9999998 Z" 
				id="Combined-Shape" 
				fill="#FFFFFF"
			></path>
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/NotSelected.js